import { HistoryContext, HistoryContextProps } from '@rhg/providers/history';
import { useContext } from 'react';

export function useHistory(): HistoryContextProps {
    return useContext(HistoryContext);
}
